import _ from "lodash"
import { useState, useEffect, useRef, forwardRef } from 'react'
import { atom, useAtom } from 'jotai'
import {preloadedAssetsAtom} from '../atoms/atom.config.js'

// simple cache/preloader for a list of images
// - img tags are added to dom
// - use preloadCB to flag a preloading state in parent
// - optional flag for rendering the preloaded images to DOM- not sure if we need this?
const PreloadedImages = (props) => {

  const renderImagesToDom = true;
  const [images, setImages] = useState([]);

  // save the loaded image paths into a global cache so we dont need to load again
  const [preloadedAssets, setPreloadedAssets] = useAtom(preloadedAssetsAtom);

  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = function() {
        resolve(img)
      }
      img.onerror = img.onabort = function() {
        reject(src)
      }
      img.src = src
    })
  }

  async function preloadImages(imagesList=[]) {
    const imagesPromiseList = []
    var globalPreloadedAssets = preloadedAssets
    var hasUpdated = false;
    for (const item of imagesList) {
        if(!globalPreloadedAssets.includes(item)) {
            imagesPromiseList.push(preloadImage(item))
            globalPreloadedAssets.push(item)
            hasUpdated = true
            //console.log("... preloadImage", item, globalPreloadedAssets)
        } else {
            console.log("*global preloadImages already attemped to preload:", item)
        }
    }

    await Promise.all(imagesPromiseList)

    if(hasUpdated) setPreloadedAssets(globalPreloadedAssets)

    // setTimeout(() => {
      // setAssetsLoaded(true)
    // },10000);
    //setAssetsLoaded(true)
    console.log("*** preloadImages complete!", imagesPromiseList.length)

    // not using the callback in parent- but adding code just in case for later
    if(props.preloadCB) {
      props.preloadCB("*** PreloadedImages items "+imagesPromiseList.length)
    }
  }

  useEffect(() => {
    if(!props.images ) return

    preloadImages(props.images)

    setImages(props.images)
    console.log("*** updated media", props.images)
  
  }, [])

  return (
    <>
        {/* // dont think we actually need to render the items to dom if we preload via the js load method? */}
      {
        renderImagesToDom && 
        images.map((item, index) => 
          <img className="inline w-[2rem] h-[2rem]" src={item} key={"pl_"+index} alt="hello" />
        )
      }
    </>
  )

};

export {
    PreloadedImages
  }